import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { InvoicesExternalService } from './../../core/services/invoices-external.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions, RowDoubleClickedEvent } from 'ag-grid';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IApiResponse, IProviders } from 'app/core/interfaces/invoice-external.interface';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { NumberValidator } from '../../core/validators-forms/max-length-number.validator.helper';

@Component({
  selector: 'app-companies-rescuenet',
  styleUrls: ['./companies-rescuenet.component.scss'],
  templateUrl: './companies-rescuenet.component.html'
})
export class CompaniesRescuenetComponent implements OnInit, OnDestroy {
  @ViewChild('modalCompany') private readonly modalCompany: T2CardComponent;
  subscription: Subscription[] = [];
  smtpSettingListCtrl: any[] = [];
  titleCard: string;
  grid: GridOptions;
  payorForm: FormGroup;
  isEditForm = false;

  constructor(
    private readonly _invoiceExternalService: InvoicesExternalService,
    private readonly sweetAlertHelper: SweetAlertHelper,
    private readonly formBuilder: FormBuilder,
    protected _loading: T2LoadingService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.initGrid();
    this.getCompanies();
    this.getSmtpSetting();
    this.modalCompany.close();
  }

  createForm() {
    this.payorForm = this.formBuilder.group({
      payorInvoiceCompanyId: [null, [Validators.required, NumberValidator.maxLength(6)]],
      description: ['', [Validators.required, Validators.maxLength(50)]],
      speedCode: ['', [Validators.required, Validators.maxLength(5)]],
      smtpSettingId: [null, Validators.required],
      emailTo: [null],
      emailCc: [null]
    });
  }

  getCompanies() {
    this.subscription.push(
      this._invoiceExternalService.getCompaniesExternal().subscribe({
        next: (value: IProviders[]) => {
          this.grid.api.setRowData((!value && !!value.length) ? [] : value.map(
            (item: IProviders) => {
              return Object.assign({}, item, {
                isEmailSetting: !!item.payorinvoicesettingid
              });
            }
          ));
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      })
    );
  }

  initGrid(): void {
    this.grid = <GridOptions>{
      enableSorting: true,
      enableFilter: true,
      enableColResize: true,
      columnDefs: [
        {
          headerName: 'Check',
          colId: 'check',
          width: 10,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          suppressFilter: true
        },
        {
          headerName: 'Company Id',
          field: 'payorinvoicecompanyid',
          width: 30
        },
        {
          headerName: 'Company',
          field: 'description',
          colId: 'description',
          width: 100
        },
        {
          headerName: 'Speed Code',
          field: 'speedcode',
          width: 40
        },
        {
          headerName: 'Email Setting',
          field: 'isProviderSeeting',
          width: 20,
          cellRendererFramework: BooleanCheckComponent
        }
      ],
      onGridReady: (params) => {
        params.api.sizeColumnsToFit();
        params.api.setRowData([]);
      },
      onRowDoubleClicked: (event: RowDoubleClickedEvent) => {
        if (event && !!event.data) {
          this.setForm(event.data);
          this.titleCard = `Edit: ${event.data.description}`;
          this.modalCompany.open();
        }
      }
    };
  }

  setForm(data) {
    const payorInvoiceCompanyIdControl = this.payorForm.get('payorInvoiceCompanyId');
    if (data) {
      this.isEditForm = true;
      this.payorForm.patchValue({
        payorInvoiceCompanyId: data.payorinvoicecompanyid,
        description: data.description,
        speedCode: data.speedcode,
        smtpSettingId: data.smtpsettingid,
        emailTo: data.emailto,
        emailCc: data.emailcc
      });
      payorInvoiceCompanyIdControl.disable();
    } else {
      payorInvoiceCompanyIdControl.enable();
    }

  }

  cancel() {
    this.modalCompany.close();
  }

  getSmtpSetting() {
    this.subscription.push(
      this._invoiceExternalService.getSmtpSetting().subscribe({
        next: (data) => {
          if (data && !!data.length) {
            this.smtpSettingListCtrl = this.mapingRespSmtpSetting(data);
          }
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      })
    );
  }

  mapingRespSmtpSetting(resp) {
    return !resp ?
      [] : resp.map((item) => {
        return {
          id: item.smtpsettingid,
          itemName: item.emailfrom
        };
      });
  }

  openModalCompany() {
    this.isEditForm = false;
    this.titleCard = 'Add: External Company';
    this.payorForm.reset();
    const payorInvoiceCompanyIdControl = this.payorForm.get('payorInvoiceCompanyId');
    payorInvoiceCompanyIdControl.enable();
    this.modalCompany.open();
  }


  save(): void {
    if (this.payorForm && this.payorForm.valid && !this.isEditForm) {
      this._loading.show();
      this.subscription.push(
        this._invoiceExternalService.postExternalCompany(this.payorForm.value)
          .finally(() => {
            this._loading.hiden();
            this.getCompanies();
          })
          .subscribe({
            next: (data: IApiResponse) => {
              if (data) {
                this.sweetAlertHelper.createCustomAlert({
                  title: data.message,
                  type: data.success ? 'success' : 'error'
                });
                this.modalCompany.close();
              }
            },
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            }
          })
      );
    } else if (this.payorForm && this.payorForm.valid) {
      const payorFormValue = this.payorForm.getRawValue();
      this.subscription.push(
        this._invoiceExternalService.putExternalCompany(payorFormValue)
          .finally(() => {
            this._loading.hiden();
            this.getCompanies();
          })
          .subscribe({
            next: (data: IApiResponse) => {
              if (data) {
                this.sweetAlertHelper.createCustomAlert({
                  title: data.message,
                  type: data.success ? 'success' : 'error'
                });
              }
            },
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            }
          })
      );
    }
  }

  get getNameButton(): string {
    return this.isEditForm ? 'Update' : 'Save';
  }

  ngOnDestroy(): void {
    if (this.subscription && !!this.subscription.length) {
      this.subscription.forEach((subscription) => subscription.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/companies-rescuenet/companies-rescuenet.component.ts